import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CustomLog } from '../../custom-classes/CustomLog';
import { RouterService } from '../../services/router.service';
import { authGuard } from '../../guards/auth-guard';
import { projectConfiguration } from '../../modules/app/app.module';
import { feature } from '../../utils/FeaturesController';
import { DeveloperService } from '../../modules/app/developer.service';
import { MatIconModule } from '@angular/material/icon';
import { MatBadge } from '@angular/material/badge';
import { CommonModule, NgClass } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';

/** State of the developer helper box */
enum BOX_STATE {
  maximized,
  minimized,
  closed,
}

/** [COMPONENT]
 *  The developer helper is a box on bottom right corner of the screen.
 *  Render all the html that is inside this component tag.
 *  Helps to test the aplication. It's only visible on local or dev.
 */
@Component({
  selector: 'app-developer-helper',
  templateUrl: './developer-helper.component.html',
  styleUrls: ['./developer-helper.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatIconModule,
    MatMenuModule,
    RouterModule,
    MatBadge,
    CommonModule,
    NgClass,
    MatBadge,
    MatIconButton,
    MatBadge,
  ],
})
export class DeveloperHelperComponent {
  status = BOX_STATE.minimized;
  s = BOX_STATE;
  errors: CustomLog[] = [];
  show: boolean = false;
  core = projectConfiguration;

  constructor(
    router: Router,
    routerS: RouterService,
    private developerS: DeveloperService,
  ) {
    /** Errors */
    this.developerS.onError.subscribe((val) => {
      this.errors.push(val);
    });
    this.developerS.onClearError.subscribe((val) => {
      this.errors = [];
    });

    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        var view = routerS.getRouteFromString(val.url);
        if (view) {
          this.show = routerS.hasGuard(view, authGuard) && feature.developerHelper;
        }
      }
    });
  }

  setMaximized() {
    if (feature.developerHelper) {
      this.status = BOX_STATE.maximized;
    }
  }
}
